import { z } from "zod";

// Shared monetary primitives for catalog items and their prices. Split out of
// catalogItem.schema.ts so catalogItemPrice.schema.ts can depend on them
// without creating a circular import (catalogItem.schema.ts also imports the
// price-operation schemas from catalogItemPrice.schema.ts for the batched
// `prices` field on updateCatalogItemSchema).

// Upper bound for monetary values stored in decimal(20,2) columns, mirroring
// the native invoice schema bound to avoid JS float precision loss.
const MONETARY_MAX = 999_999_999_999;

export const unitAmountSchema = z
    .number()
    .finite()
    .min(-MONETARY_MAX)
    .max(MONETARY_MAX)
    .describe(
        "Major currency units, not cents. 10000 with currency usd is $10,000.00. Do not divide by 100.",
    );

export const currencySchema = z
    .string()
    .regex(/^[a-zA-Z]{3}$/)
    .transform((value) => value.toLowerCase());
